import style from "./../styles/Loader.module.css";

const Loader = () => {
  return (
    <div className={style.ldsEllipsis}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loader;
